import React, { PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';
import { useContextMenuState } from '../../hooks/useContextMenuState';
import { DropdownField } from './partials/DropdownField';
import { DropdownMenu } from './partials/DropdownMenu';
import styles from './Dropdown.module.scss';

export const Dropdown = ({
    label,
    renderPreview: Preview,
    maxHeight, fieldClassName, className,
    children
}: Props) => {

    const element = useRef<HTMLDivElement>(null);
    const [isOpen, setOpen] = useContextMenuState(element);

    return (
        <div ref={element} className={classNames(className, styles.default)}>
            {label && <h6 className={styles.label}>{label}</h6>}
            <DropdownField
                active={isOpen} onClick={() => setOpen(!isOpen)}
                className={fieldClassName}>
                <Preview />
            </DropdownField>

            <DropdownMenu onClick={() => setOpen(false)} maxHeight={maxHeight} isOpen={isOpen}>
                {children}
            </DropdownMenu>
        </div>
    );
};

type Props = PropsWithChildren<{
    label?: string;
    renderPreview: () => JSX.Element | null;
    className?: string;
    fieldClassName?: string;
    maxHeight?: number;
    activeByDefault?: boolean;
    onCancel?: () => void;
}>;